<!--
  «Altas de comercios» — la bandeja. Cuatro cortes de la misma cola de solicitudes: lo que me toca
  a mí, lo que espera a mi perfil, lo que ya tomó otro de mi perfil, y el histórico completo.
-->
<div class="kb-page kb-gateway">

  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title">Altas de comercios</h1>
      <p class="kb-page-meta">Las solicitudes de comercios que quieren entrar a CrediTotal, según le toquen a tus perfiles.</p>
    </div>
    <div *ngIf="bandeja?.puede_crear">
      <a class="kb-btn kb-btn-primary !text-primary-foreground" [routerLink]="['/console/altas/nueva']">
        <i class="fas fa-plus" aria-hidden="true"></i>Nueva solicitud de alta
      </a>
    </div>
  </div>

  <div class="space-y-6" *ngIf="cargando" aria-hidden="true">
    <div class="kb-skeleton h-9 w-64"></div>
    <div class="kb-skeleton h-56 w-full"></div>
  </div>
  <p class="sr-only" *ngIf="cargando">Cargando las solicitudes de alta.</p>

  <div class="kb-aviso kb-aviso-peligro" *ngIf="!cargando && error">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
    <div>
      <p class="kb-aviso-titulo">No se pudieron traer las solicitudes</p>
      <p>{{ error }}</p>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-3" (click)="reintentar()">
        <i class="fas fa-redo" aria-hidden="true"></i>Volver a consultar
      </button>
    </div>
  </div>

  <ng-container *ngIf="!cargando && !error && bandeja">

    <!-- El núcleo dice que el usuario no tiene ningún perfil del workflow del alta (bandeja.tengo_perfil). -->
    <div class="kb-aviso kb-aviso-info" *ngIf="sinPerfilDeAlta">
      <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
      <div>
        <p class="kb-aviso-titulo">No te toca ninguna solicitud</p>
        <p>Tu usuario no tiene ninguno de los perfiles del alta (ejecutivo, gerente o aprobador final): puedes ver todas, pero no te toca ninguna.</p>
      </div>
    </div>

    <div class="kb-card">
      <div class="kb-card-header">
        <div>
          <p class="kb-seccion-rotulo">Bandeja</p>
          <p class="kb-card-desc">Toca una solicitud para ver su expediente y decidir.</p>
        </div>
      </div>

      <!-- Separadas de la línea del encabezado: `pt-[16px]` y no `pt-4`, que el Bootstrap viejo vuelve 24 px con !important. -->
      <div class="px-6 pt-[16px] pb-4 overflow-x-auto">
        <div class="kb-tabs-list" role="tablist" aria-label="Corte de la bandeja">
          <a class="kb-pestana" [class.kb-pestana-activa]="corte === 'me_tocan'" role="tab"
             [attr.aria-selected]="corte === 'me_tocan'" [routerLink]="[]" [queryParams]="{ corte: 'me_tocan' }">
            Asignadas a mí <span class="kb-pestana-num">· {{ bandeja.me_tocan.length }}</span>
          </a>
          <a class="kb-pestana" [class.kb-pestana-activa]="corte === 'por_tomar'" role="tab"
             [attr.aria-selected]="corte === 'por_tomar'" [routerLink]="[]" [queryParams]="{ corte: 'por_tomar' }">
            Sin asignar <span class="kb-pestana-num">· {{ bandeja.por_tomar.length }}</span>
          </a>
          <a class="kb-pestana" [class.kb-pestana-activa]="corte === 'de_otros'" role="tab"
             [attr.aria-selected]="corte === 'de_otros'" [routerLink]="[]" [queryParams]="{ corte: 'de_otros' }">
            Asignadas a otros <span class="kb-pestana-num">· {{ bandeja.de_otros.length }}</span>
          </a>
          <a class="kb-pestana" [class.kb-pestana-activa]="corte === 'todas'" role="tab"
             [attr.aria-selected]="corte === 'todas'" [routerLink]="[]" [queryParams]="{ corte: 'todas' }">
            Todas
          </a>
        </div>
      </div>

      <!-- El buscador: filtra en la página la lista del corte activo, por comercio o por RIF. -->
      <div class="px-6 pb-4" *ngIf="filas.length || busqueda">
        <div class="kb-buscador max-w-sm">
          <i class="fas fa-search kb-buscador-icono" aria-hidden="true"></i>
          <input type="text" class="kb-input kb-input-icono w-full" id="buscarAlta"
                 placeholder="Comercio o RIF" aria-label="Buscar por comercio o RIF"
                 [(ngModel)]="busqueda">
        </div>
      </div>

      <!-- «Todas» se pide aparte: mientras llega, un cargando solo de la tabla (las pestañas se quedan). -->
      <div class="px-6 pb-6" *ngIf="corte === 'todas' && cargandoTodas" aria-hidden="true">
        <div class="kb-skeleton h-40 w-full"></div>
      </div>
      <p class="sr-only" *ngIf="corte === 'todas' && cargandoTodas">Cargando todas las solicitudes.</p>

      <div class="kb-aviso kb-aviso-peligro mx-6 mb-6" *ngIf="corte === 'todas' && !cargandoTodas && errorTodas">
        <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
        <div>
          <p class="kb-aviso-titulo">No se pudo traer «todas»</p>
          <p>{{ errorTodas }}</p>
          <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-3" (click)="reintentar()">
            <i class="fas fa-redo" aria-hidden="true"></i>Volver a consultar
          </button>
        </div>
      </div>

      <ng-container *ngIf="!(corte === 'todas' && (cargandoTodas || errorTodas))">
        <div class="kb-card-body-plano" *ngIf="!filasFiltradas.length">
          <p class="text-sm text-muted-foreground px-6 pb-6">{{ busqueda.trim() && filas.length ? mensajeSinResultados : mensajeVacio }}</p>
        </div>

        <div class="kb-table-envoltorio" *ngIf="filasFiltradas.length">
          <table class="kb-table">
            <thead class="kb-thead">
              <tr>
                <th class="kb-th">Número</th>
                <th class="kb-th">Comercio</th>
                <th class="kb-th">RIF</th>
                <th class="kb-th">Etapa</th>
                <th class="kb-th">Perfil</th>
                <th class="kb-th kb-th-num">Días en la etapa</th>
                <th class="kb-th">Responsable</th>
                <th class="kb-th"><span class="sr-only">Abrir</span></th>
              </tr>
            </thead>
            <tbody>
              <tr class="kb-tr kb-tr-clic last:border-b-0" *ngFor="let f of filasFiltradas; trackBy: porId"
                  [routerLink]="['/console/altas', f._id]" (keydown.enter)="irA(f)">
                <td class="kb-td whitespace-nowrap"><code class="rounded bg-muted px-1.5 py-0.5 font-mono text-xs">{{ f.numero }}</code></td>
                <td class="kb-td">
                  <span class="kb-td-titulo" *ngIf="f.comercio">{{ f.comercio }}</span>
                  <span class="text-muted-foreground" *ngIf="!f.comercio">—</span>
                  <p class="kb-td-sub kb-texto-alerta" *ngIf="f.etapa?.devuelta_por as d">Te la devolvió el {{ d.rol_nombre }} ({{ d.username }}): mira su comentario.</p>
                  <p class="kb-td-sub kb-texto-alerta" *ngIf="f.falta">{{ f.falta }}</p>
                  <!-- No frena (cambio de Juan, §5): en kb-hint, nunca en alerta. -->
                  <p class="kb-td-sub kb-hint" *ngIf="f.documentos_faltan">Faltan {{ f.documentos_faltan }} documentos</p>
                </td>
                <td class="kb-td whitespace-nowrap">{{ f.rif || '—' }}</td>
                <td class="kb-td">
                  <span class="kb-badge" [ngClass]="insigniaAprobada(f).clase" *ngIf="f.estado === 'APROBADA'">{{ insigniaAprobada(f).texto }}</span>
                  <span class="kb-badge kb-badge-peligro" *ngIf="f.estado === 'RECHAZADA'">Rechazada</span>
                  <ng-container *ngIf="f.estado === 'EN_CURSO'">
                    <span *ngIf="f.etapa">{{ f.etapa.orden }}<ng-container *ngIf="f.etapas_total"> de {{ f.etapas_total }}</ng-container> · {{ f.etapa.rol_nombre }}</span>
                    <span class="text-muted-foreground" *ngIf="!f.etapa">—</span>
                  </ng-container>
                </td>
                <td class="kb-td">
                  <span *ngIf="f.actuo_como">{{ f.actuo_como }}</span>
                  <span class="text-muted-foreground" *ngIf="!f.actuo_como">—</span>
                </td>
                <td class="kb-td kb-td-num">
                  <ng-container *ngIf="diasEnEtapa(f) !== null; else sinDias">{{ diasEnEtapa(f) }}</ng-container>
                  <ng-template #sinDias><span class="text-muted-foreground">—</span></ng-template>
                </td>
                <td class="kb-td">{{ laTiene(f) }}</td>
                <td class="kb-td text-right">
                  <a class="!text-muted-foreground hover:!text-foreground" [routerLink]="['/console/altas', f._id]"
                     [attr.aria-label]="'Abrir ' + f.numero" (click)="$event.stopPropagation()">
                    <i class="fas fa-chevron-right" aria-hidden="true"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
